import { freightDeliveryAccessorialPresetIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const setDefaultFreightDeliveryAccessorialPreset = {
  name: "setDefaultFreightDeliveryAccessorialPreset" as const,
  input: z.object({ id: freightDeliveryAccessorialPresetIdFormat.schema }),
  output: z.object({}),
};
